import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CircularProgressBar = ({ percentage }) => {

  const isPositive = percentage >= 0;


  const styles = {
    path: {
      stroke: isPositive ? "#2ecc71" : "#FE3745",
      strokeWidth: "8px",
      strokeLinecap: "butt"
    },
    trail: {
      transform: isPositive ? "rotate(-0.35turn)" : "rotate(0.35turn)",
      transformOrigin: "center center",
      stroke: "#dfe6e9",
      strokeWidth: "8px",
      strokeLinecap: "butt"
    },
    text: {
      fill: "#242731",
      fontSize: "12px",
    }
  };

  return (
    <CircularProgressbar
      value={Math.abs(percentage) < 100 ? Math.abs(percentage / 2) : 50}
      text={isPositive ? `+ ${percentage}%` : `- ${Math.abs(percentage)}%`}
      circleRatio={0.7}
      styles={styles}
      counterClockwise={!isPositive}
    />
  );
};

export default CircularProgressBar;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/CircularProgressBar.js